import { ApplicationTemplateApi } from "src/services/Api/Organization/types";
import { ReactComponent as GoposSVG } from "../../../../../../../../images/svg/apps/large/gopos.svg";
import { Providers } from "../../services/types";

interface Props {
	app: ApplicationTemplateApi;
}

export const RenderAppIcon = ({ app }: Props) => {
	if (app.logo_link) {
		return <img className={"application-template-logo"} src={app.logo_link} />;
	}

	if (app.provider === Providers.GOPOS || app.provider === Providers.GOPOS_V2) return <GoposSVG />;

	return <img className={"application-template-logo"}></img>;
};
